// extracted by mini-css-extract-plugin
module.exports = {"phone-input":"styles-module__phone-input___23Z5B","phone-input-disabled":"styles-module__phone-input-disabled___2upe5"};